export type CatalogAddress = {
    address1: string;
    address2: string;
    city: string;
    country: string;
    fullCountryName: string;
    lat: number;
    lng: number;
    postalCode: string;
    state: string;
};

export enum CatalogPaymentMethods {
    Amex = 'po-amexaccepted',
    Bitcoin = 'po-bitcoinaccepted',
    Discover = 'po-discoveraccepted',
    MoneyOrder = 'po-moneyorderaccepted',
    PersonalChecks = 'po-personalchecksaccepted',
    VisaMasterCard = 'po-visamastercardaccepted',
    Wire = 'po-wireaccepted',
}

export enum CatalogPaymentMethodAccepted {
    Off = 'off',
    On = 'on',
}

export type CatalogPaymentOption = {
    [CatalogPaymentMethods.Amex]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.Bitcoin]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.Discover]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.MoneyOrder]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.PersonalChecks]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.VisaMasterCard]: CatalogPaymentMethodAccepted;
    [CatalogPaymentMethods.Wire]: CatalogPaymentMethodAccepted;
    'so-shipwhere': string;
    'sp-buyerpaysshippingactual': CatalogPaymentMethodAccepted;
};

export type Catalog = {
    absenteeBidders: number;
    achPayments: boolean;
    address: CatalogAddress;
    // possibly numeric boolean?
    atgPay: number;
    billingCheckout: boolean;
    buyersPremium: {
        high: number;
        low: number;
        lowCutoff: number;
        middle: number;
        middleCutoff: number;
    };
    catalogId: number;
    catalogStatus: string;
    currency: string;
    currencySymbol: string;
    description: string;
    escrowSupported: boolean;
    hasExplicitMaterial: boolean;
    hasVideo: boolean;
    highRiskPayments: boolean;
    // an enum from the backend
    housePassingOrAbsorbingFee: number;
    imagePath?: string;
    isAutopay: boolean;
    isCatalogOnly: boolean;
    isInstantAutopay: boolean;
    isSEOExcluded: boolean;
    isTimed: boolean;
    isTimedPlus: boolean;
    liveAuctioneersPayments: boolean;
    lotsListed: number;
    paymentOptions: CatalogPaymentOption;
    payrixPayments: boolean;
    preview: string;
    publishDateTs: number;
    // possibly numeric boolean?
    requiredAch: number;
    saleEndEstimatedTs: number;
    saleEndTs: number;
    saleStartTs: number;
    sellerId: number;
    title: string;
};

export const emptyCatalog: Catalog = {
    absenteeBidders: 0,
    achPayments: false,
    address: {
        address1: '',
        address2: '',
        city: '',
        country: '',
        fullCountryName: '',
        lat: 0,
        lng: 0,
        postalCode: '',
        state: '',
    },
    atgPay: 0,
    billingCheckout: false,
    buyersPremium: {
        high: 0,
        low: 0,
        lowCutoff: 0,
        middle: 0,
        middleCutoff: 0,
    },
    catalogId: 0,
    catalogStatus: '',
    currency: '',
    currencySymbol: '',
    description: '',
    escrowSupported: false,
    hasExplicitMaterial: false,
    hasVideo: false,
    highRiskPayments: false,
    housePassingOrAbsorbingFee: 0,
    imagePath: '',
    isAutopay: false,
    isCatalogOnly: false,
    isInstantAutopay: false,
    isSEOExcluded: false,
    isTimed: false,
    isTimedPlus: false,
    liveAuctioneersPayments: false,
    lotsListed: 0,
    paymentOptions: {
        [CatalogPaymentMethods.Amex]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.Bitcoin]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.Discover]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.MoneyOrder]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.PersonalChecks]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.VisaMasterCard]: CatalogPaymentMethodAccepted.Off,
        [CatalogPaymentMethods.Wire]: CatalogPaymentMethodAccepted.Off,
        'so-shipwhere': '',
        'sp-buyerpaysshippingactual': CatalogPaymentMethodAccepted.Off,
    },
    payrixPayments: false,
    preview: '',
    publishDateTs: 0,
    requiredAch: 0,
    saleEndEstimatedTs: 0,
    saleEndTs: 0,
    saleStartTs: 0,
    sellerId: 0,
    title: '',
};
